// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/admin/dashboard',
    },
    {
      title: 'تعریف وام ها',
      icon: 'mdi-chart-bubble',
      to: '/admin/loans/',
    },
    {
      title: 'لیست اعضای صندوق',
      icon: 'mdi-account-multiple',
      to: '/admin/members/',
    },
    {
      title: 'دریافت فایل اقساط',
      icon: 'mdi-file-excel-outline',
      to: '/admin/installmentsimport/',
    },
    {
      title: 'دریافت فایل پس انداز ها',
      icon: 'mdi-file-excel-outline',
      to: '/admin/savedMoneyimport/',
    },
    {
      title: 'اعتبارسنجی باقیمانده اقساط',
      icon: 'mdi-file-excel-outline',
      to: '/admin/remainComparer/',
    },
    {
      title: 'درخواست وام ها',
      icon: 'mdi-bell',
      to: '/admin/userLoanRequests/',
    },
    {
      title: 'گزارش ها',
      icon: 'mdi-format-list-numbered-rtl',
      to: '/admin/reports/',
    },
    {
      title: 'هزینه ها',
      icon: 'mdi-flower-tulip',
      to: '/admin/expense/',
    },
    {
      title: 'کاربران',
      icon: 'mdi-account',
      to: '/admin/users/',
    },
  ],
  memberItems: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/member/dashboard',
    },
    {
      title: 'لیست وام ها',
      icon: 'mdi-account-multiple',
      to: '/member/loans/',
    },
    {
      title: 'پس اندازها',
      icon: 'mdi-account-cash',
      to: '/member/savedMoney/',
    },
    {
      title: 'درخواست وام',
      icon: 'mdi-bell',
      to: '/member/loanRequest/',
    },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
